import {useEffect, useRef} from 'react';

/*
 * Execute the hook only when the component updates and not when the component is mounted.
 * */
// eslint-disable-next-line typescript/no-explicit-any -- Pre-existing any
export function useDidUpdate(fn: () => void, dependencies?: any[]) {
  const mounted = useRef(false);

  useEffect(function runOnUpdate() {
    if (mounted.current) {
      fn();
    } else {
      mounted.current = true;
    }
  }, dependencies); // eslint-disable-line react/exhaustive-deps -- Muted pre-existing violation
}
